import { FilterSelectField } from "components/formFields/FilterSelectField";

import { i18n } from "services/i18nService";

import { SYNC_ITEM_ACTIONS, AUDIT_EVENT_ACTIONS } from "appConstants";

const ALL_ACTION_OPTION = { id: "", name: i18n("filter.All") };

const OPTIONS = {
  syncitem: [ALL_ACTION_OPTION, ...SYNC_ITEM_ACTIONS],
  auditevent: [ALL_ACTION_OPTION, ...AUDIT_EVENT_ACTIONS],
};

export function EditActionFilter(props) {
  const { filters, setFilters, objectType } = props;
  const { filterSettings } = filters;
  const { Action = "" } = filterSettings;

  function handleChange(_, value) {
    setFilters((prevParams) => ({
      ...prevParams,
      filterSettings: {
        ...prevParams.filterSettings,
        Action: value?.id || "",
      },
      startingRecord: 1,
    }));
  }
  return (
    <FilterSelectField
      options={OPTIONS[objectType]}
      onValueChange={handleChange}
      value={{ id: Action }}
      label={i18n("filter.Action")}
      dataTesting="statusFilter"
      disableClearable
    />
  );
}
